import { Component, Injector, Inject, OnInit } from '@angular/core';
import { ContactBaseComponent } from './../common-theme/index';
import { OpenModalService } from '../common-theme/base-components/shared/modals/open-modal.service';
import { AgencyService } from '../common-theme/api/agency.service';
import { DOCUMENT } from '@angular/platform-browser';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})

export class ContactComponent extends ContactBaseComponent implements OnInit {
  constructor(
    injector: Injector,
    agencyService: AgencyService,
    @Inject('WINDOW') window: any,
    @Inject(DOCUMENT) private document: any,
    private openModalService: OpenModalService
  ) {
    super(injector, agencyService, window);
  }

  openMessageModal(): void {
    this.openModalService.showContactFormModal();

    if (this.document)
      this.document.body.classList.add('no-scroll');
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.setTitle('Contactează echipa proiectului Romanescu Park Residence');

    this.setMetaDescription(`
      O locuință la Romanescu Park Residence îți va aduce o viață nouă, mai aproape de natură.
      Contactează-ne la numărul de telefon: +40726307128 dacă vrei să afli mai multe detalii despre
      apartamentele noastre.
    `);
  }
}



// WEBPACK FOOTER //
// ./src/app/contact/contact.component.ts